export default __webpack_public_path__ + "static/header_background-c1ae8bcdb21b47598a5ae96330556d1c.webp";